import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react';
import _ from 'lodash';

import './MultiSelectField.css';

const MultiSelectField = ({ name, value, options, placeholder, fixedWidth, onSelectChange, ...rest }) => {
    const { t } = useTranslation();

    const Component = (props) => {
        const { input } = props;
        const onChange = (e, data) => {
            input.onChange(data.value);
            if ('onChange' in rest)
                rest.onChange(e, data);
        }

        const otherProps = {};
        if (value)
            otherProps.value = value;
        if ('clearable' in rest)
            otherProps.clearable = rest.clearable;

        // ensure that all the selected values (found in the input)
        // are present in the provided options
        if (input.value !== '') {
            options = options?.concat(_.difference(
                input.value,
                options.map(o => o.value)
            ).map(id => ({
                key: id,
                text: `[${t('common.unknown')} - ${id}]`,
                className: "line-through",
                value: id
            })));
        }

        return <Dropdown
            name={ name }
            options={options}
            defaultValue={ input.value }
            onChange={ onChange }
            placeholder={ placeholder }
            fluid={ !fixedWidth || fixedWidth === 'undefined' }
            multiple
            selection
            search
            {...otherProps}
        />;
    }

    return (
        <div className="MultiSelectField">
            <Field multiple name={ name } component={ Component } onChange={ onSelectChange } className="form-control" />
        </div>
    );
}

export default MultiSelectField;
